import React from "react";
import { Control } from "@assets/spa/control/text";
export function ForminatorText(props) {
    const { placeholder, onChange, value, } = props;
    return React.createElement(Control, { value: value || '', onChange: onChange, placeholder: placeholder });
}
